import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/lib/data";

export default function FAQ() {
  return (
    <section data-testid="faq-section" className="py-24 lg:py-32 bg-[#FDFBFA]">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <span className="eyebrow">Questions answered</span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl mt-4 text-[#041047] tracking-tight leading-[1.1]">
            Frequently asked <em className="italic font-medium">questions</em>.
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-[#041047]/15"
            >
              <AccordionTrigger className="text-left font-display text-lg md:text-xl text-[#041047] py-6 hover:no-underline hover:text-[#041047] [&[data-state=open]>svg]:text-[#D4AF37]">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#475569] text-[0.98rem] leading-relaxed pb-6 pr-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
